import { useState } from "react";
import styled from "styled-components";

import FormComp from "../../../Componentes/FormComp";
import Overlay from "../../../Componentes/Overlay";
import Formulario from "../../../Componentes/Utils/Formulario";
import Modal from "../../../Componentes/Utils/Modal";
import { useModal } from "../../../contexts/ModalContext";
import { useToast } from "../../../contexts/ToastContext";
import useApi from "../../../hooks/useApi";

const ModalTitle = styled.h3`
    margin: 0 0 18px 0;
    padding: 0 0 12px 2px;
    border-bottom: 1px solid #e5e7eb;
    font-size: 15px;
    font-weight: 700;
    color: #263b4b;
    text-align: left;
    width: 100%;
`;

const ModalNovaQueixa = ({ onCreated }) => {
    const { closeModal } = useModal();
    const api = useApi();
    const { notifyError, notifySuccess } = useToast();

    const [descricao, setDescricao] = useState("");
    const [salvando, setSalvando] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const valor = descricao.trim();
        if (!valor) {
            notifyError("Informe a descrição da queixa.");
            return;
        }

        try {
            setSalvando(true);

            const { data } = await api.post(
                "/Painel/API/AtendimentoAmb/Queixas/Save/index.php",
                { descricao: valor }
            );

            if (data?.success) {
                notifySuccess(data?.message || "Queixa cadastrada com sucesso.");
                if (onCreated) await onCreated();
                closeModal();
                return;
            }

            notifyError(data?.message || "Não foi possível salvar a queixa.");
        } catch (err) {
            console.error(err);
            const msg = err?.response?.data?.message || "Erro ao salvar queixa.";
            notifyError(msg);
        } finally {
            setSalvando(false);
        }
    };

    return (
        <Overlay state>
            <Modal header close={closeModal} size="sm">
                <ModalTitle>NOVA QUEIXA / OCORRÊNCIA</ModalTitle>
                <Formulario onSubmit={handleSubmit}>
                    <FormComp
                        title="DESCRIÇÃO"
                        type="text"
                        valor={descricao}
                        changeFunc={(e) => setDescricao(e.target.value)}
                        placeholder="Ex.: DOR DE CABEÇA"
                        required
                    />
                    <FormComp
                        type="submit"
                        valor={salvando ? "SALVANDO…" : "SALVAR"}
                        disabled={salvando}
                    />
                </Formulario>
            </Modal>
        </Overlay>
    );
};

export default ModalNovaQueixa;
